import React from 'react'

import { Grid, TextField, Typography, MenuItem, Box } from '@material-ui/core'

import useAddBundle from './useAddBundle'

import { AddBundleFormProps, BundleType } from '../../model/bundles.model'

export default function AddBundleForm({
  id,
  preselected,
  setAddBundle,
  dataHook,
  type,
}: AddBundleFormProps) {
  const { onSelect, availableBundles, selected } = useAddBundle(id, type, setAddBundle, preselected)

  const isBonus = type === BundleType.BONUS

  return (
    <Grid container spacing={5}>
      <Grid item component={Box} minWidth="500px">
        <TextField
          variant="outlined"
          label={isBonus ? 'Bono' : 'Descuento'}
          data-hook={dataHook}
          value={selected === 0 ? '' : selected}
          select
          onChange={(e) => onSelect(parseInt(e.target.value, 10))}
        >
          {availableBundles.map((bundle) => (
            <MenuItem key={`bundle-${bundle?.id}`} value={bundle?.id}>
              <Box display="flex" width="100%">
                <Box mr={1}>
                  <Typography>{bundle?.name}</Typography>
                </Box>
                <Typography>
                  {bundle.durationText.map((text) => (
                    <span key={`${text.payment}-bundle-price`}>
                      {text.pretext}
                      <strong>{text.payment}</strong>
                      {text.duration}
                    </span>
                  ))}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </Grid>
  )
}
